import { Card, CardContent, CardHeader, CardTitle } from "@shadcn-in-nx/ui/card";
import { Badge } from "@shadcn-in-nx/ui/badge";
import { useTranslation } from "react-i18next";

const STATUS_STYLES = {
    match: "bg-green-100 text-green-800",
    warning: "bg-yellow-100 text-yellow-800",
    error: "bg-red-100 text-red-800",
};

export default function AuditCard({ title, icon: Icon, data }) {
    const { t } = useTranslation();

    if (!data) return null;

    const statusLabel = t(`admin.facebookAudit.status.${data.matchStatus}`);
    const statusStyle = STATUS_STYLES[data.matchStatus] || "";

    return (
        <Card>
            <CardHeader className="pb-2">
                <CardTitle className="text-sm font-medium text-muted-foreground flex items-center gap-2">
                    {Icon && <Icon className="h-4 w-4" />}
                    {title}
                </CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
                <div className="flex justify-between items-center">
                    <span className="text-sm text-muted-foreground">
                        {t("admin.facebookAudit.dbCount")}
                    </span>
                    <span className="text-lg font-bold">{data.db}</span>
                </div>
                <div className="flex justify-between items-center">
                    <span className="text-sm text-muted-foreground">
                        {t("admin.facebookAudit.fbCount")}
                    </span>
                    <span className="text-lg font-bold">{data.facebook}</span>
                </div>
                <div className="flex justify-between items-center border-t pt-2">
                    <span className="text-sm font-medium">
                        {t("admin.facebookAudit.difference")}
                    </span>
                    <div className="flex items-center gap-2">
                        <span className="text-lg font-bold">
                            {data.diff > 0 ? `+${data.diff}` : data.diff}
                        </span>
                        <Badge className={statusStyle}>{statusLabel}</Badge>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
